export enum PlayerStatus {
	Starting = 0,
	Substitute = 10,
	Inactive = 20,
}